module.exports = __webpack_public_path__ + "static/media/faq.42a8ad8d.jpg";